module.exports = __webpack_public_path__ + "static/img/投诉建议.b267518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/投诉建议.jpg
// module id = iOhy
// module chunks = 17